/**
 * <christmas-reveal> — the "8 mystery designs" teaser page.
 *
 * Counts down to the reveal; at zero it sets [data-revealed], and the CSS
 * swaps the countdown and the vote link for the "shop the winners" button.
 */
class ChristmasReveal extends HTMLElement {
  static SECOND_MS = 1000;

  connectedCallback() {
    this.revealAt = new Date(this.dataset.revealAt).getTime();
    this.tick();
    if (!this.hasAttribute('data-revealed')) {
      this.timer = setInterval(() => this.tick(), ChristmasReveal.SECOND_MS);
    }
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  tick() {
    const remaining = Math.max(0, this.revealAt - Date.now());
    const totalSeconds = Math.floor(remaining / ChristmasReveal.SECOND_MS);
    const parts = {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor(totalSeconds / 3600) % 24,
      minutes: Math.floor(totalSeconds / 60) % 60,
      seconds: totalSeconds % 60,
    };
    Object.entries(parts).forEach(([unit, value]) => {
      const slot = this.querySelector(`[data-countdown="${unit}"]`);
      if (slot) slot.textContent = String(value).padStart(2, '0');
    });
    if (remaining === 0) {
      this.setAttribute('data-revealed', '');
      clearInterval(this.timer);
    }
  }
}

customElements.define('christmas-reveal', ChristmasReveal);
